/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { combinationsDependencies } from './dependenciesCombinations.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { isNegativeDependencies } from './dependenciesIsNegative.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCatalan } from '../../factoriesAny.js';
export var catalanDependencies = {
  addScalarDependencies,
  combinationsDependencies,
  divideScalarDependencies,
  isIntegerDependencies,
  isNegativeDependencies,
  multiplyScalarDependencies,
  typedDependencies,
  createCatalan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesCatalan.generated.js
// module id = 1324
// module chunks = 2